import { EventEmitter, ElementRef } from '@angular/core';
var TimeInputComponent = (function () {
    function TimeInputComponent() {
        this.hourValue = undefined;
        this.hourChange = new EventEmitter();
        this.minuteValue = undefined;
        this.minuteChange = new EventEmitter();
        this.class = 'null';
    }
    Object.defineProperty(TimeInputComponent.prototype, "hour", {
        get: function () {
            return this.hourValue;
        },
        set: function (val) {
            this.hourValue = val;
            this.hourChange.emit(this.hourValue);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TimeInputComponent.prototype, "minute", {
        get: function () {
            return this.minuteValue;
        },
        set: function (val) {
            this.minuteValue = val;
            this.minuteChange.emit(this.minuteValue);
        },
        enumerable: true,
        configurable: true
    });
    TimeInputComponent.prototype.classes = function () {
        var classes = {};
        classes['showPlaceholder'] = this.showPlaceholder;
        classes[this.class] = true;
        return classes;
    };
    TimeInputComponent.prototype.reset = function () {
        this.showPlaceholder = true;
        this.inputHour.nativeElement.value = '';
        this.inputMinute.nativeElement.value = '';
        this.minuteValue = undefined;
        this.hourValue = undefined;
    };
    TimeInputComponent.prototype.ngOnInit = function () {
        if (this.hourValue != undefined) {
            this.inputHour.nativeElement.value = this.hour.toString();
            this.blurHour();
        }
        if (this.minuteValue != undefined) {
            this.inputMinute.nativeElement.value = this.minute.toString();
            this.blurMinute();
        }
        if (!this.inputHour.nativeElement.value && !this.inputMinute.nativeElement.val) {
            this.showPlaceholder = true;
        }
    };
    TimeInputComponent.prototype.focused = function () {
        if (this.showPlaceholder) {
            this.inputHour.nativeElement.click();
            this.inputHour.nativeElement.focus();
            this.showPlaceholder = false;
        }
    };
    TimeInputComponent.prototype.blurHour = function () {
        if (this.hourValue < 10) {
            this.inputHour.nativeElement.value = '0' + this.hourValue;
        }
    };
    TimeInputComponent.prototype.blurMinute = function () {
        if (this.minuteValue < 10) {
            this.inputMinute.nativeElement.value = '0' + this.minuteValue;
        }
    };
    TimeInputComponent.prototype.keyUp = function (event) {
        if (this.inputHour.nativeElement === document.activeElement) {
            this.evaluateHour(this.inputHour.nativeElement.value);
            this.showPlaceholder = false;
        }
        else if (this.inputMinute.nativeElement === document.activeElement) {
            /**
            * Focus Hour Input when Backspace on empty Minute
            */
            if (event.key === 'Backspace' && this.minute === undefined) {
                this.inputHour.nativeElement.focus();
            }
            this.evaluateMinute(this.inputMinute.nativeElement.value);
            this.showPlaceholder = false;
        }
    };
    TimeInputComponent.prototype.evaluateHour = function (text) {
        if (Number(text) === this.hour) {
            return;
        }
        if (text === '') {
            this.inputHour.nativeElement.value = '';
            return;
        }
        var num = Number(text);
        if (isNaN(num)) {
            this.inputHour.nativeElement.value = this.hour || '';
            return;
        }
        else {
            if (num < 10 && num > 0) {
                this.hour = Math.floor(num);
            }
            else if (num >= 0 && num < 24) {
                this.hour = Math.floor(num);
            }
            this.inputHour.nativeElement.value = this.hour;
        }
        /**
         * Autofocus Minute Input when Hour Input is finished
         */
        if (this.inputHour.nativeElement.value.length === 2) {
            this.inputMinute.nativeElement.focus();
        }
    };
    TimeInputComponent.prototype.evaluateMinute = function (text) {
        if (Number(text) === this.minute) {
            return;
        }
        if (text === '') {
            this.inputMinute.nativeElement.value = '';
            this.minute = undefined;
            return;
        }
        var num = Number(text);
        if (isNaN(num)) {
            this.inputMinute.nativeElement.value = this.minute || '';
            return;
        }
        else {
            if (num < 10 && num > 0) {
                this.minute = Math.floor(num);
            }
            else if (num >= 0 && num < 60) {
                this.minute = Math.floor(num);
            }
            this.inputMinute.nativeElement.value = this.minute;
        }
    };
    return TimeInputComponent;
}());
export { TimeInputComponent };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/time-input/time-input.component.ts.pre-build-optimizer.js